<template>
  <div class="variants-container mb-6">
    <h3 class="font-semibold mb-2">
      Varianten
    </h3>
    <div
      v-for="(variantItem, index) in value"
      :key="index"
      class="variant-item mb-4 p-4 border rounded"
    >
      <div class="flex justify-between mb-2">
        <h4 class="font-medium">
          Variante {{ index + 1 }}
        </h4>
        <button
          v-if="value.length > 1"
          class="text-red-600 hover:text-red-800"
          @click="removeVariant(index)"
        >
          Entfernen
        </button>
      </div>

      <div class="mb-4">
        <input-select-validated
          v-model="variantItem.variant"
          input-class="w-full"
          label="Variante"
          rules="required"
          :options="variantOptions"
        />
      </div>

      <div class="mb-2">
        <input-text-validated
          v-model="variantItem.templateId"
          input-class="w-full"
          label="Template ID"
          rules="required"
          placeholder="763fdeae-b11b-4b9c-b27a-77c9c9556afe"
        />
      </div>
    </div>

    <button
      class="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      @click="addVariant"
    >
      {{ $t('components.form.creatifyVariants.addVariant') }}
    </button>
  </div>
</template>

<script>
import InputTextValidated from '@/components/form/text-validated'
import InputSelectValidated from '@/components/form/select-validated'

export default {
  components: {
    InputTextValidated,
    InputSelectValidated
  },

  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      variantOptions: [
        { value: 'DV1', name: 'DV1' },
        { value: 'DV2', name: 'DV2' },
        { value: 'DV3', name: 'DV3' },
        { value: 'DV4', name: 'DV4' },
        { value: 'REMAX', name: 'REMAX' },
        { value: 'VOLKSBANK', name: 'VOLKSBANK' },
        { value: 'CHV1', name: 'CHV1' },
        { value: 'CHV2', name: 'CHV2' },
        { value: 'CHIT', name: 'CHIT' },
        { value: 'CHFR', name: 'CHFR' },
        { value: 'ATV1', name: 'ATV1' },
        { value: 'LIGHT', name: 'LIGHT' }
      ]
    }
  },

  methods: {
    addVariant () {
      this.value.push({
        variant: '',
        templateId: ''
      })
    },

    removeVariant (index) {
      this.value.splice(index, 1)
    }
  }
}
</script>
